export type TwoFactorChallenge = {
  challengeToken: string;
  email?: string;
  expiresIn?: number;
};

export function unwrapAuthData(payload: any) {
  return payload?.data?.data ?? payload?.data ?? payload;
}

export function getTwoFactorChallenge(payload: any): TwoFactorChallenge | null {
  const data = unwrapAuthData(payload);
  const challengeToken =
    data?.challenge_token ??
    data?.challengeToken ??
    payload?.challenge_token ??
    payload?.challengeToken;

  if (typeof challengeToken !== 'string' || challengeToken.length === 0) {
    return null;
  }

  const expiresIn = Number(data?.expires_in ?? data?.expiresIn);

  return {
    challengeToken,
    email: typeof data?.email === 'string' ? data.email : undefined,
    expiresIn:
      Number.isFinite(expiresIn) && expiresIn > 0 ? expiresIn : undefined,
  };
}

export function getAuthErrorMessage(
  payload: any,
  fallback = 'The request could not be completed.'
) {
  const data = unwrapAuthData(payload);
  const message =
    payload?.message ??
    payload?.error?.message ??
    data?.message ??
    data?.error?.message;

  return typeof message === 'string' && message.trim() ? message : fallback;
}
